module.exports = __webpack_public_path__ + "static/media/profile-pic.5cd06131.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/profile-pic.svg
// module id = 164
// module chunks = 0